import { useState, useEffect } from "react";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { motion } from "framer-motion";
import Sidebar from "../components/Sidebar";
import '../assets/css/themeSelector.css';
import { themeSelectorIcons } from '../assets/images/themeSelector';
import ThemesList from "../components/themes/ThemesList";
import SideCustomModal from "../components/themes/sideCustomModal";
import { BASE } from "../api/client";

export default function ThemeSelector() {
    const [searchQuery, setSearchQuery] = useState("");
    const { user } = useCurrentUser();
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [selectedSubTheme, setSelectedSubTheme] = useState(null);
    const [themes, setThemes] = useState([]);
    const [loading, setLoading] = useState(true);

    const role = localStorage.getItem("userRole");
    const canCreateAccount = role === "ADMIN";

    // Charger les thèmes depuis la BDD
    useEffect(() => {
        async function fetchThemes() {
            try {
                const res = await fetch(`${BASE}/api/games/themes/?level=B1`);
                if (res.ok) {
                    const data = await res.json();
                    setThemes(data);
                } else {
                    console.error("Erreur chargement thèmes:", res.status);
                }
            } catch (err) {
                console.error("Erreur connexion API thèmes:", err);
            } finally {
                setLoading(false);
            }
        }
        fetchThemes();
    }, []);

    const filteredThemes = themes.filter((theme) => {
        const query = searchQuery.toLowerCase();
        const matchesThemeName = theme.name.toLowerCase().includes(query);
        const matchesSubTheme = theme.subThemes.some((sub) =>
            sub.toLowerCase().includes(query)
        );
        return matchesThemeName || matchesSubTheme;
    });

    return (
        <div className="page-container">
            <Sidebar />
            <div className="content-container">
                <div className="container-fluid">
                    <div className="userGreeting">
                        <span className="typoBlackStar">Hello {user?.first_name || user?.username || ""},</span><br />
                        <span style={{ display: "none" }}>Lorem ipsum</span>
                    </div>
                    <div className="searchAndFilters mt-4">
                        <div className="search-bar">
                            <input
                                type="text"
                                className="searchInput"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <img src={themeSelectorIcons.search} className="solidinterfacesearch-icon" alt="Rechercher" />
                        </div>
                        <div className="filter-icons" style={{ display: "none" }}>
                            <div className="filter"></div>
                            <div className="random"></div>
                            <div className="save"></div>
                        </div>
                    </div>

                    {loading ? (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.3 }}
                        >
                            Chargement des thèmes...
                        </motion.p>
                    ) : filteredThemes.length > 0 ? (
                        <ThemesList
                            themes={filteredThemes}
                            searchQuery={searchQuery}
                            selectedTheme={selectedTheme}
                            setSelectedTheme={setSelectedTheme}
                            selectedSubTheme={selectedSubTheme}
                            setSelectedSubTheme={setSelectedSubTheme}
                        />
                    ) : (
                        <motion.p
                            className="no-result"
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, ease: "easeOut" }}
                        >
                            Aucun résultat trouvé
                        </motion.p>
                    )}
                </div>
            </div>
            <SideCustomModal
                setSelectedTheme={setSelectedTheme}
                selectedTheme={selectedTheme}
                setSelectedSubTheme={setSelectedSubTheme}
                selectedSubTheme={selectedSubTheme}
            />
        </div>
    );
}